import C from 'actionTypes'
import { XmlEntities } from 'html-entities'

import { formatClassName } from 'utils/Client/classAllocationsConfig'

const defaultState = {
  primaryPortfolioClassAllocations: {
    portfolioId: null,
    classAllocations: []
  },
}

const primaryPortfolioClassAllocations = (state = defaultState, action) => {
  switch (action.type) {
    case C.SET_PRIMARY_PORTOFLIO_CLASS_ALLOCATIONS:
      const { data: { id, classAllocations } } = action
      return {
        ...state,
        primaryPortfolioClassAllocations: {
          portfolioId: id,
          classAllocations: [
            ...classAllocations.map(classAllocation => ({
              ...classAllocation.attributes,
              className: formatClassName(
                XmlEntities.decode(classAllocation.attributes.className)
              )
            }))
          ]
        },
      }
    default:
      return state
  }
}
export default primaryPortfolioClassAllocations



// WEBPACK FOOTER //
// ./src/reducers/client/primaryPortfolioClassAllocations.js